/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './ketone.reducer';

export const KetoneDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const ketoneEntity = useAppSelector(state => state.ketone.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="ketoneDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.ketone.detail.title">Ketone</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.ketone.id">Id</Translate>
            </span>
          </dt>
          <dd>{ketoneEntity.id}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.ketone.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{ketoneEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.ketone.active">Active</Translate>
            </span>
          </dt>
          <dd>{ketoneEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.ketone.created">Created</Translate>
            </span>
          </dt>
          <dd>{ketoneEntity.created ? <TextFormat value={ketoneEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.ketone.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{ketoneEntity.microSec}</dd>
          <dt>
            <span id="reading">
              <Translate contentKey="tinyMedicRestApp.ketone.reading">Reading</Translate>
            </span>
          </dt>
          <dd>{ketoneEntity.reading}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.ketone.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{ketoneEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.ketone.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{ketoneEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.ketone.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{ketoneEntity.glucoUser ? ketoneEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/ketone" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/ketone/${ketoneEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default KetoneDetail;
